import React from 'react';
import { FiUsers, FiUserCheck, FiActivity, FiTrendingUp, FiGift } from 'react-icons/fi';
import { FaRupeeSign } from 'react-icons/fa';

/**
 * ReferralStats Component
 * Displays referral system statistics in card format
 */
const ReferralStats = ({ stats, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="bg-white p-6 rounded-xl shadow-md animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-1/2 mb-4"></div>
            <div className="h-8 bg-gray-200 rounded w-3/4"></div>
          </div>
        ))}
      </div>
    );
  }

  const statCards = [
    {
      label: 'Current Percentage',
      value: `${stats?.current_percentage ?? 0}%`,
      icon: <FiTrendingUp className="text-2xl" />,
      color: 'bg-blue-500',
      bgLight: 'bg-blue-50',
    },
    {
      label: 'Total Users',
      value: stats?.total_users ?? 0,
      icon: <FiUsers className="text-2xl" />,
      color: 'bg-indigo-500',
      bgLight: 'bg-indigo-50',
    },
    {
      label: 'Users With Referrer',
      value: stats?.users_with_referrer ?? 0,
      icon: <FiUserCheck className="text-2xl" />,
      color: 'bg-green-500',
      bgLight: 'bg-green-50',
    },
    {
      label: 'Total Transactions',
      value: stats?.total_transactions ?? 0,
      icon: <FiActivity className="text-2xl" />,
      color: 'bg-purple-500',
      bgLight: 'bg-purple-50',
    },
    {
      label: 'Onboarding Referrals',
      value: stats?.onboarding_referrals ?? 0,
      icon: <FiGift className="text-2xl" />,
      color: 'bg-orange-500',
      bgLight: 'bg-orange-50',
    },
    {
      label: 'Event Referrals',
      value: stats?.event_referrals ?? 0,
      icon: <FiActivity className="text-2xl" />,
      color: 'bg-pink-500',
      bgLight: 'bg-pink-50',
    },
    {
      label: 'Total Rewards Distributed',
      value: `₹${(stats?.total_rewards_distributed ?? 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
      icon: <FaRupeeSign className="text-2xl" />,
      color: 'bg-emerald-500',
      bgLight: 'bg-emerald-50',
      fullWidth: true,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {statCards.map((card, index) => (
        <div
          key={index}
          className={`${card.bgLight} p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 ${
            card.fullWidth ? 'md:col-span-2 lg:col-span-3' : ''
          }`}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm font-medium mb-1">{card.label}</p>
              <p className="text-2xl font-bold text-gray-800">{card.value}</p>
            </div>
            <div className={`${card.color} text-white p-4 rounded-full`}>
              {card.icon}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReferralStats;
